import React from 'react';
import { motion } from 'framer-motion';
import { UserSearch, Building2, LineChart, ShieldCheck, ArrowRight } from 'lucide-react';

const AuditTypes = () => {
  // Fonction pour scroller vers l'ID du CTA
  const scrollToCTA = () => {
    const ctaElement = document.getElementById('ctaOsint');
    if (ctaElement) {
      ctaElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const audits = [
    {
      title: "Audit individuel",
      icon: <UserSearch size={18} strokeWidth={2} className="text-blue-600" />,
      description: "Diagnostic OSINT personnel Analyse de l'exposition des informations publiques ,Analyse des emails, réseaux sociaux et traces numériques ,Analyse de la réputation en ligne",
      link: "Détails"
    },
    {
      title: "Audit entreprise",
      icon: <Building2 size={18} strokeWidth={2} className="text-blue-600" />,
      description: "Analyse de l'exposition numérique globale de l'entreprise ,Analyse des domaines, emails et données accessibles publiquement Identification des risques de fraude, de phishing et de concurrence",
      link: "Détails"
    },
    {
      title: "Audit veille",
      icon: <LineChart size={18} strokeWidth={2} className="text-blue-600" />,
      description: "Veille cyber et exposition continue Détection de fuites de données Alertes d'exposition en temps réel Rapports périodiques Possibilité d'échanges réguliers avec un expert",
      link: "Détails"
    },
    {
      title: "Offres Dirigeants / RSSI / Profils sensibles",
      icon: <ShieldCheck size={18} strokeWidth={2} className="text-blue-600" />,
      description: "Audit exécutif OSINT et exposition stratégique Analyse avancée de l'exposition personnelle et professionnelle Corrélation entre l'entreprise et les individus clés",
      link: "Détails"
    }
  ];

  const springTransition = { 
    type: "spring", 
    stiffness: 100, 
    damping: 18, 
    mass: 1 
  };

  return (
    <section className="w-full bg-white flex flex-col items-center" style={{ padding: '60px 24px' }}>
      
      <div className="text-center mb-10 max-w-[600px]">
        <motion.h2 
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={springTransition}
          style={{ fontSize: '32px', fontWeight: 900, color: '#0f172a', letterSpacing: '-0.03em', marginBottom: '12px' }}
        >
          Types d'audit
        </motion.h2>
        <motion.p 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          style={{ fontSize: '14px', color: '#64748b', lineHeight: 1.5 }}
        >
          Des solutions sur-mesure adaptées à chaque profil de risque et besoin opérationnel.
        </motion.p>
      </div>

      <motion.div 
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={{
          hidden: { opacity: 0 },
          show: {
            opacity: 1,
            transition: { staggerChildren: 0.1 }
          }
        }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-[1000px] w-full"
      >
        {audits.map((audit, idx) => (
          <motion.div
            key={idx}
            variants={{
              hidden: { opacity: 0, y: 20 },
              show: { opacity: 1, y: 0, transition: springTransition }
            }}
            whileHover={{ 
              y: -6, 
              backgroundColor: "#ffffff",
              boxShadow: "0 15px 30px rgba(15, 23, 42, 0.06)" 
            }}
            // La carte entière devient cliquable pour scroller
            onClick={scrollToCTA}
            className={`group p-6 rounded-2xl bg-[#f8fafc] border border-slate-100 flex flex-col items-start transition-all duration-300 cursor-pointer
              ${idx === 3 ? "lg:col-start-2" : ""}`}
          >
            <div className="bg-white p-2.5 rounded-xl shadow-sm border border-slate-100 mb-5 transition-transform group-hover:scale-105">
              {audit.icon}
            </div>

            <h3 style={{ color: '#0f172a', fontSize: '16px', fontWeight: 800, marginBottom: '12px', letterSpacing: '-0.01em' }}>
              {audit.title}
            </h3>

            <div className="flex-grow">
              <p style={{ color: '#64748b', fontSize: '12px', lineHeight: 1.6, marginBottom: '20px' }}>
                {audit.description}
              </p>
            </div>

            <motion.button 
              whileHover={{ x: 3 }}
              className="flex items-center gap-1 text-[#3b82f6] text-[12px] font-bold"
              style={{ background: 'none', border: 'none', padding: 0 }}
            >
              {audit.link} <ArrowRight size={14} />
            </motion.button>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default AuditTypes;